import HTTP from '@/plugins/axios';

// Partner privacy policy HTML — the same text the applicant cabinet shows in its gate.
// Edited per partner in the admin (privacy_policy_text), falls back to a translation on the backend.
export const getPrivacyPolicyText = async(params: { lang: string, sid: string, type?: string }) => {
  const response = await HTTP.get('/user/privacy_policy', {
    params,
  });
  return response.data;
};
